import {
  constructionAsset,
  constructionSafety,
  logisticsAsset,
  medicalPatient,
  medicalWaste,
  retailOffice,
  retailExhibition,
} from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingSteel/video/rtlsVideo.mp4';

export default {
  desc: 'Gần đây, các doanh nghiệp đang tích cực triển khai Hệ thống Định vị Thời gian Thực (RTLS) để nâng cao năng suất và tối đa hóa hiệu quả sử dụng tài nguyên.',
  keywords: 'RFID, RTLS, UWB, giải pháp, rfid, rtls, uwb, giai phap.',
  ogSite: 'Các tiêu chí quan trọng để chọn nhà cung cấp RTLS',
  title: 'Các tiêu chí quan trọng để chọn nhà cung cấp RTLS',
  ogUrl: 'https://orbro.io/vi/blog/rtlsCompany',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDwtIISjDSVCDSnp4Nx3cGb1Ozp2BSmcdnEapCFup7uDaNWXxV2V1-fB8A3HklTGwTcrHkdZ_cA7VDTUd4UkTfLspAq0d4uZPq6ZeulzJqvcifS9Bw-xfTVTFgfZXklSlXh1rq8NsXP6Ah2aN-bYrwpNREltJcCR5HW7d-IJmK-9gIpde_688lL9UU2BeQ5E0P1A2ESvEXcd8-LuzUEVRs3e3jfbDPxSjg9ydKLvn705yJSBD6rpEUC5iU8jQGXfKbB2Hr7A88JMwRLphNHv6zieJqhSM1dv8ESi8X3l8jH3DBJB7E8xvlicUOt1-QvsMD65qm87niZDWettcJyS6XnpOwmmmhHTqiLe-0DzPjVRtGmz1mkzs3JHNrhxNp40cCE6NK3Mp5RQBKUy190oEUBDb1bb2MLa-cs_xu8wcwQLNf8K_d9HDtyMlsLD6XHKShUDydJm2H9iNfI2TsHCpj6qOmc5IfB42F4WCFQuGHtpbKj7mKOvCe1BqtRhoXzmAtiHmghM8jzrLZQkWCMDJE79cfRTqO-JSBpPwJi0g-Zov4puGycni3TFAD7lHlCAKw8wLWn6xZuaCkMGG79wJ32p6xa_Gp2JLiSbVJNsqYu1BWb54Wwb5tVdGsx8W8tWYwv3BzJqrafHi9FtyYaKunD2m3qcDZNbkcTyIcXeQsOcj8C2BEp9WiOJELl6A_etzBinI5fHqf6UwTzJ_LTJ-FtBHkB-5bH-qIitO-2Gf2FxzgXE65QclQQhjI_nD25uwKI6Gos0YU0s4EwlQoIlcptoFn8dWovqaERvfkgME5C8EgN_W8HKqq5J8j6kUqUwnT_dJR9QTJDp2MDFFUeF6vV_R8-eq_qquZuYhfQDKqVcx6SSkIgQB8p_pJ-Q_DJZCg-4iLTx3gP7b24S32g5jEMhTnx0zpHHsdzc8MIxzySrRt5bT5AfNasqvrWHqPWa_t9MM-0iHWjR9lR8hWEL17y8XdEKjF5igOYGdR0UEvs1ZcFGvvNTV3vdiNCk3rNaC89ZJ9m6olPqAFIcdEbc2qAgG78-MbI33yCmidAD9hPBPR2dyPg_pXmHHqIlXT14EoAoDu18wbBu_wQP41ZPemWH-X-U_BUK2IdUQJP4CvLlFNs6ghZbwn13En9tXaPpl0SFBQB5v6riEQxDujwiMEvoi65V8m170vbu8L-NRuQ5KJoWd2GOmxBhOtupoe3t4FTv-DjmFjImqiCeGOq4-iyWcmU55jv4gk1_ugniXiZVGSGpvb2WJJABeN6xgNiT_9z_L6VwCfK6aMHs9cE8S_sv2yc2qBi3_SeEM5xTIr8pmU_qG4r1P_C1GVdiinD8I8c56mIUcX4Sz8chmHYiLwlTtIlj1nweMwToAiXHsvztud9HFsIdPNvBaVIkvl-6I7a0UHtkO699f9aK2qT2MiYWrueCLYE9V3_ibpgYgbxxyS5crADSB-7YJ--6S4n6eD-r4bUkMHVz97z6X6HV_uHS5B4jce8CeOOdEUpUMMvTgWZ6Hs7FP4fGhrAwhGUTRFRsZ_93Z7YmOWXx4WJLxdyoABRmg3TOA1ghvuCqDjiUA14wOTD3=w1775-h1190',
  ogType: 'website',
  date: '2023-11-15',
  tag1: '#Rfid',
  tag2: '#Rtls',
  tag3: '#Uwb',
  tag4: '#Giaiphap',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Gần đây, các doanh nghiệp đang tích cực triển khai Hệ thống Định vị Thời gian Thực (RTLS) để nâng cao năng suất và tối đa hóa hiệu quả sử dụng tài nguyên. Tuy nhiên, khi lựa chọn hệ thống RTLS, cần phải xem xét nhiều tiêu chí khác nhau. Bài viết này sẽ xem xét chi tiết hơn về các tiêu chí chính cần cân nhắc khi chọn nhà cung cấp RTLS.',
      dot: '',
    },
    {
      head: 'Mức độ hoàn thiện và độ chính xác của công nghệ',
      subHead: '',
      desc: 'Cốt lõi của hệ thống RTLS nằm ở độ chính xác của thông tin vị trí. Cần phải xác minh xem công nghệ của nhà cung cấp đã hoàn thiện đến mức nào và liệu có cung cấp thông tin vị trí chính xác hay không. Đặc biệt, có thể đánh giá một cách đáng tin cậy năng lực kỹ thuật của nhà cung cấp thông qua việc đánh giá hiệu suất công nghệ và các trường hợp sử dụng thực tế.',
      dot: '',
    },
    {
      head: 'Khả năng ứng dụng trong các môi trường đa dạng',
      subHead: '',
      desc: 'Doanh nghiệp thực hiện nhiều công việc khác nhau trong các môi trường đa dạng. Do đó, cần xác nhận xem hệ thống RTLS có thể hoạt động hiệu quả trong nhiều môi trường khác nhau hay không. Hãy kiểm tra xem nhà cung cấp đảm bảo việc thử nghiệm và ứng dụng trong các môi trường đa dạng như thế nào, và cân nhắc năng lực cung cấp giải pháp phù hợp cho nhiều lĩnh vực công nghiệp.',
      dot: '',
    },
    {
      head: 'Khả năng mở rộng và tính linh hoạt',
      subHead: '',
      desc: 'Quy mô hoặc yêu cầu kinh doanh của doanh nghiệp có thể thay đổi theo thời gian. Điều quan trọng là nhà cung cấp RTLS có khả năng dễ dàng mở rộng và điều chỉnh hệ thống một cách linh hoạt. Đồng thời, hãy thu thập thông tin về việc liệu có dễ dàng áp dụng các công nghệ mới hoặc các bản cập nhật hay không.',
      dot: '',
    },
    {
      head: 'Phân tích chi phí và ROI (Tỷ suất hoàn vốn)',
      subHead: '',
      desc: 'Việc triển khai RTLS phát sinh chi phí đầu tư, do đó cần xem xét cẩn thận cả về mặt chi phí. Hãy tìm hiểu chính sách giá của nhà cung cấp và phân tích lợi tức đầu tư dự kiến (ROI) sau khi triển khai để xem xét lợi ích đầu tư dài hạn. Hãy đưa ra quyết định tối ưu cho doanh nghiệp bằng cách tính toán chính xác hiệu quả so với chi phí.',
      dot: '',
    },
    {
      head: 'An ninh và bảo vệ thông tin cá nhân',
      subHead: '',
      desc: 'Thông tin dựa trên vị trí có thể là tài sản quan trọng của doanh nghiệp. Hãy xác minh xem nhà cung cấp RTLS có chính sách mạnh mẽ về an ninh dữ liệu và bảo vệ thông tin cá nhân hay không. Việc tuân thủ các quy định và quy tắc cũng là một yếu tố cân nhắc quan trọng. Điều quan trọng là chọn một hệ thống có thể bảo vệ an toàn dữ liệu của khách hàng.',
      dot: '',
    },
    {
      head: 'Hỗ trợ khách hàng và dịch vụ',
      subHead: '',
      desc: 'Hệ thống RTLS đòi hỏi phản ứng nhanh chóng nếu có sự cố xảy ra. Hãy đánh giá chất lượng dịch vụ và hỗ trợ kỹ thuật của nhà cung cấp, đồng thời tìm hiểu xem họ cung cấp những chương trình đào tạo và huấn luyện nào. Ngoài ra, hãy xác minh xem khả năng giải quyết vấn đề và chăm sóc khách hàng của nhà cung cấp có xuất sắc hay không để xây dựng mối quan hệ hợp tác đáng tin cậy.\nHệ thống RTLS có thể đóng một vai trò quan trọng trong hoạt động của doanh nghiệp, do đó, việc lựa chọn nhà cung cấp RTLS dựa trên những tiêu chí đa dạng này sẽ giúp bạn xây dựng được một hệ thống định vị hiệu quả. Lựa chọn nhà cung cấp phù hợp sẽ góp phần vào sự tăng trưởng và gia tăng hiệu quả trong tương lai của doanh nghiệp.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: retailOffice.thumb,
        data: 'retailOffice',
        link: '/vi/enterprise/retail/office',
      },
    ],
  },
};
